/*
  Input Text
*/

import React from "react";

// Antd
import { Input, InputNumber, Form } from "antd";

// Localization
import LOCALIZATION from "../../../../services/LocalizationService";

function Number({
  name,
  label,
  placeholder,
  readOnly,
  defaultValue,
  value,
  onChange,
  disabled,
  required,
  onBlur,
  validator,
  validateTrigger,
  maxLength,
  notwrapInForm,
  min,
  max,
  step,
  precision,
  rules: customRules,
}) {
  // Rules - Use custom rules if provided, otherwise create default ones
  let rules = customRules || [
    { required: required, message: LOCALIZATION.REQUIRED },
  ];

  // Custom Validations - only add if no custom rules provided
  if (!customRules && validator) {
    rules.push(validator);
  }

  // Input Number
  const InputNumberComponent = (
    <InputNumber
      placeholder={placeholder || label}
      onChange={onChange || null}
      defaultValue={defaultValue}
      value={value}
      disabled={disabled}
      onBlur={onBlur}
      readOnly={readOnly}
      min={min}
      max={max}
      step={step}
      precision={precision}
      style={{ width: '100%' }}
      controls={true}
    />
  );

  if (notwrapInForm) {
    return InputNumberComponent;
  }

  return (
    <Form.Item
      name={name}
      label={label}
      validateTrigger={validateTrigger || "onBlur"}
      rules={rules}
    >
      {InputNumberComponent}
    </Form.Item>
  );
}

export default Number;
